module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noData":"No region or address data given."},"es":{"noData":"No se proporcionaron datos de región o dirección."},"sw":{"noData":"Hakuna eneo au data ya anwani iliyotolewa."}}')
  delete Component.options._Ctor
}
